import { e as u } from "../separate-component-helper-chunks/base-CwU3eNq-.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let e;
function c(t) {
  return (o, n) => u(o, n, { get() {
    var r;
    return ((r = this.renderRoot) != null ? r : e != null ? e : e = document.createDocumentFragment()).querySelectorAll(t);
  } });
}
export {
  c as queryAll
};
